import * as Yup from 'yup';

export const schema = Yup.object().shape({
	email: Yup.string()
		.email('invalid-email')
		.required('required'),
	password: Yup.string(),
});
